import { Controller } from '@hotwired/stimulus'

// A small show/hide disclosure — e.g. a chapter's summary in the story table of
// contents, collapsed by default. The trigger toggles the panel's `hidden`,
// reflects state on aria-expanded, and rotates an optional chevron.
//
//   data-controller="disclosure"
//   trigger button → data-action="disclosure#toggle" data-disclosure-target="trigger"
//   chevron (optional) → data-disclosure-target="chevron"
//   panel → data-disclosure-target="panel" hidden
export default class extends Controller {
  static targets = ['panel', 'trigger', 'chevron']

  toggle() {
    const opening = this.panelTarget.hidden
    this.panelTarget.hidden = !opening
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute('aria-expanded', String(opening))
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle('rotate-180', opening)
  }
}
